const STORAGE_KEY = 'vammo_auth_token'

export function getStoredToken(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function storeToken(token: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, token)
  } catch {
    // sessionStorage unavailable (e.g. private browsing quota exceeded)
  }
}

export function clearStoredToken(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

export function extractTokenFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search)
  return params.get('token')
}

export function removeTokenFromUrl(): void {
  const url = new URL(window.location.href)
  url.searchParams.delete('token')
  window.history.replaceState({}, '', url.toString())
}

export function decodeToken(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded) as Record<string, unknown>
  } catch {
    return null
  }
}

/** Return the stable authenticated-user claim used to namespace local preferences. */
export function getTokenUserId(token: string | null): string | null {
  if (!token) return null
  const claims = decodeToken(token)
  if (!claims) return null

  for (const claim of ["sub", "userId", "user_id", "id"] as const) {
    const value = claims[claim]
    if (typeof value === "string" && value.trim()) return value.trim()
    if (typeof value === "number" && Number.isFinite(value)) return String(value)
  }
  return null
}

/** Permissions carried by the token, read like the backend auth-lib: permissions, perms or scopes. */
export function getTokenPermissions(token: string | null): string[] {
  if (!token) return []
  const claims = decodeToken(token)
  if (!claims) return []
  const raw = claims.permissions ?? claims.perms ?? claims.scopes
  if (Array.isArray(raw)) return raw.filter((item): item is string => typeof item === "string")
  if (typeof raw === "string") return raw.split(",").map((item) => item.trim()).filter(Boolean)
  return []
}
